export default {
  path: '/reset-password/:resetToken',
  name: 'ResetPassword',
  component: () => import(/* webpackChunkName: "reset-password" */ '../../views/ResetPassword.vue'),
};
